'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _keyMirror2.default)({
  REQUEST_VISITOR_CONTEXT: null,
  SUCCEED_GETTING_VISITOR_CONTEXT: null,
  FAIL_GETTING_VISITOR_CONTEXT: null
});
module.exports = exports['default'];